import React, { useState } from "react";
import Lottie from "lottie-react";
import updateAnimation from "../../../Assets/animation/change.json";
import { toast } from "react-toastify";
import AuthUser from "../../../Hooks/authUser";
import UpdateHooks from "../../../Hooks/UpdateHooks";
import { server_url } from "../../../Config/API";
import { Icon } from "@iconify/react";

const ChangePassword = () => {
  const { userInfo } = AuthUser();
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [retypeNewPassword, setRetypeNewPassword] = useState("");

  const handleChangePassword = async (e) => {
    e.preventDefault();

    if (newPassword !== retypeNewPassword) {
      toast.error("New passwords do not match.");
      return;
    }

    if (!userInfo || !userInfo._id) {
      toast.error("User Not Found");
      return;
    }

    const BASE_URL = `${server_url}/user/change-password/${userInfo._id}`;
    await UpdateHooks(
      BASE_URL,
      {
        email: userInfo.email,
        newPassword,
        oldPassword,
      },
      true,
      "Password Changed Successfully"
    );

    setOldPassword("");
    setNewPassword("");
    setRetypeNewPassword("");
    e.target.reset();
  };

  return (
    <div className="max-w-5xl mx-auto select-none space-y-6">
      {/* Header card */}
      <div className="flex items-center gap-3 bg-white p-6 rounded-2xl border border-slate-100 shadow-sm">
        <div className="p-3 bg-indigo-50 text-indigo-600 rounded-xl">
          <Icon icon="solar:lock-keyhole-minimalistic-bold" className="w-6 h-6" />
        </div>
        <div>
          <h1 className="text-lg font-black text-slate-800 tracking-tight">Security Credentials</h1>
          <p className="text-xs text-slate-400 font-semibold mt-0.5">Update and secure your account password</p>
        </div>
      </div>

      {/* Main card */}
      <div className="bg-white rounded-2xl border border-slate-100 shadow-sm p-6 lg:p-8 grid grid-cols-1 md:grid-cols-12 items-center gap-8 lg:gap-12">
        <div className="md:col-span-5 flex justify-center max-w-sm mx-auto w-full">
          <Lottie animationData={updateAnimation} className="w-full max-h-72 object-contain" />
        </div>
        <form className="md:col-span-7 space-y-4" onSubmit={handleChangePassword}>
          <div className="space-y-4">
            <PasswordField
              label="Current Password"
              value={oldPassword}
              setValue={setOldPassword}
              icon="solar:lock-outline"
            />
            <PasswordField
              label="New Password"
              value={newPassword}
              setValue={setNewPassword}
              icon="solar:key-outline"
            />
            <PasswordField
              label="Re-type New Password"
              value={retypeNewPassword}
              setValue={setRetypeNewPassword}
              icon="solar:shield-keyhole-outline"
            />
          </div>

          <div className="pt-2">
            <button
              className="w-full py-2.5 bg-gradient-to-r from-cyan-500 to-blue-600 hover:opacity-95 text-white font-extrabold text-xs rounded-xl shadow-md shadow-cyan-500/10 hover:-translate-y-0.5 transition-all duration-300 cursor-pointer flex items-center justify-center gap-2"
              type="submit"
            >
              <Icon icon="solar:shield-check-bold" className="w-4 h-4" />
              <span>Update Password</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

const PasswordField = ({ label, value, setValue, icon }) => {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <div className="space-y-1.5">
      <label className="block text-[11px] font-bold text-slate-500 uppercase tracking-wide">{label}</label>
      <div className="relative">
        <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-slate-400">
          <Icon icon={icon} className="w-4 h-4" />
        </div>
        <input
          className="w-full pl-10 pr-10 py-2.5 rounded-xl border border-slate-200 focus:outline-none focus:ring-2 focus:ring-indigo-500/20 focus:border-indigo-500 text-xs font-semibold text-slate-800"
          type={showPassword ? "text" : "password"}
          value={value}
          onChange={(e) => setValue(e.target.value)}
          required
          placeholder="••••••••"
        />
        <button
          type="button"
          onClick={() => setShowPassword(!showPassword)}
          className="absolute inset-y-0 right-0 pr-3 flex items-center text-slate-400 hover:text-slate-650 cursor-pointer"
        >
          <Icon icon={showPassword ? "solar:eye-closed-outline" : "solar:eye-outline"} className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};

export default ChangePassword;
